<template>
  <div class='h-topogjxx-sidebj' :style="styleColorVar">
		
		<div class='h-toolbarBg h-topo-margin'>
        <div :class='[hasBorder ? "h-borderBox-top" : "h-inputBox"]' >
            <div :class='{"col-xs-12 col-sm-12 col-lg-12 col-md-12": hasBorder}' >
                <ejs-textbox :placeholder='$t("System.inputTip7")' @keydown.enter.native="search" v-model='input' />
            </div>
        </div>
    </div>
        
	    <ejs-grid :dataSource='fmData' ref='topoalarmgrid' :class=' { "h-borderBox-content": hasBorder }'  :detailTemplate ='detailTemplate' :allowReordering='true' :allowResizing='true' >
	    <e-columns>
		      <!-- TODO field 需要变 -->
		        <e-column field='alarmID' :headerText='$t("Alarm.alarmID")' textAlign='Center' minWidth='10' width='8%' clipMode='EllipsisWithTooltip'  ></e-column>
		        <e-column field='alarmName' :headerText='$t("Alarm.alarmName")' textAlign='Center' minWidth='10' width='8%' clipMode='EllipsisWithTooltip' ></e-column>
		        <e-column field='levelStr' :headerText='$t("Alarm.alarmLevel")' textAlign='Center' clipMode='EllipsisWithTooltip' :disableHtmlEncode='false' :formatter='levelFormat' minWidth='10' width='8%' ></e-column>
		        <e-column field='confirmStateStr' :headerText='$t("Alarm.confirmState")' textAlign='Center'  :formatter='confirmFormat' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
		        <e-column field='alarmTypeStr' :headerText='$t("Alarm.alarmType")' textAlign='Center' clipMode='EllipsisWithTooltip' :formatter='typeFormat' minWidth='10' width='8%'></e-column>
		        <e-column field='neAlarmFDN' :headerText='$t("Alarm.neAlarmFDN")' textAlign='Center'  clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
		        <e-column field='createTimeFormat' :headerText='$t("Alarm.createTime")' textAlign='Center' clipMode='EllipsisWithTooltip' minWidth='10' width='8%'></e-column>
		   </e-columns>
	    </ejs-grid>
      
  </div>
</template>

<script>
 //加入Provide ContextMenu后关闭窗口报错
import { DetailRow,   Reorder, Resize,GridPlugin } from "@syncfusion/ej2-vue-grids";
import DetailTemp from "./DetailTemp";


let dataSource = [];
export default {
  name: 'AlarmShowDialog',
  props: [
    'hasBorder'  ],
  components: {
  
    DetailTemp,
  },
  data() {
    return {
      styleColorVar:{},
      input:'',
       page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0
      },
      queryConditions: {
        systemId: '1',
        conditions: '', // 告警过滤时会有查询条件，筛调部分告警，初始化时需获取初始条件
        keywords: '', // 模糊查询关键字
      },
      fmData: [],
      roleNetList : [],
      roleNe:[],
      conditions: {
        alarmTime: {
          createTime: '',
          clearTime: '',
          confirmTime: ''
        },
        alarmLevel: [],
        alarmType: [],
        nodeIds: [],
        ne: [],
        alarmState:{
          clearState: 0,
          confirmState: ''
        },
        UserId: '',
      },
      
      
      detailTemplate: function () {
        return { template: DetailTemp };
      },
    }
  },
  provide: {
    grid: [DetailRow,Reorder, Resize]
  },
  methods: {
    clearFormat(grid, data) {
      return this.$t(`Alarm.alarmClearStatus_${data.clearState}`);
    },
    levelFormat(grids, data) {
      return `<span class='h-alarmLevel${data.level}'>${this.$t(`Alarm.alarmLevel_${data.level}`)}</span>`;
    },
    beforeMount(id) {
      const This = this;
      this.$loading.showLoadding(this.$t('Software.Searching'));
      This.$axios.get('/lte/ems/auth/findNodeIdByAuth').then((response) => {
        if (response && response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            This.roleNetList.push(response.data[i]);
          }
          this.getAlarmListData(id);
        }
      })
    },
    getAlarmListData(id) {
      const neIds=[10];
      const This = this;
      const l=This.roleNetList;
      if (id instanceof Array) {
        this.conditions.nodeIds = id;
      } else {
        this.conditions.nodeIds = [id];
      }
      const principal = sessionStorage.getItem('principal');
      const user = JSON.parse(principal);
      this.conditions.UserId = user.userId;
      This.$axios.post('/lte/ems/fm/alarmcurrent/queryAlarm.html', {
        conditions: JSON.stringify(this.conditions),
        keywords: "",
        roleNe:l
      }).then((response) => {
        if (response && response.status === 200) {
          this.$loading.hideLoadding();
          this.dataSource = response.data.resultVal;
          this.fmData = this.dataSource;
          this.$refs.topoalarmgrid.ej2Instances.dataSource = this.dataSource;
        }
      });
    },

    search(args) {
      if(this.input === '') {
          this.fmData = this.dataSource;
          this.$refs.topoalarmgrid.ej2Instances.dataSource = this.dataSource;
      }
      else {

        var filterdata = this.dataSource.filter( item => {
            let columntext = Array.from(this.$refs.topoalarmgrid.getColumns(), x => {
              return x.field;
            });

            let feildData = Array.from(columntext, x => {
              return item[x] === null ? '' : item[x] +'';
            });
            let filres = false;
            feildData.forEach(item => {
              if(item.indexOf(this.input) > -1)
              {
                filres = true;
              }
            });
            return filres;
        }).map( item => { return item });
        this.fmData = filterdata;
        this.$refs.topoalarmgrid.ej2Instances.dataSource = filterdata;

      }
    },
    
    
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.topoalarmgrid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return false;
      }
      return selectedRecords;
    },
    
    
    typeFormat(grid, data) {
      let str = this.$t(`Alarm.alarmType_${data.alarmType}`);
      data.alarmTypeStr = str;
      return str;
    },
    confirmFormat(grid, data) {
      let str = this.$t(`Alarm.alarmConfirmStatus_${data.confirmState}`);
      data.confirmStateStr = str;
      return str;
    },
  },
  mounted() {
    this.styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
  },
}
</script>
